// extracted by mini-css-extract-plugin
export var active = "_ls-e";
export var blink = "_ls-f";
export var dropDownSelector = "_ls-5";
export var dropDownWrapper = "_ls-4";
export var fakeCursor = "_ls-d";
export var fontSizeButton = "_ls-7";
export var formQuillEditor = "_ls-0";
export var pressed = "_ls-g";
export var qlBlank = "_ls-1";
export var textFormattingToolbar = "_ls-2";
export var textFormattingToolbarClosed = "_ls-3";
export var textFormattingToolbarInline = "_ls-6";
export var textToolbarOption = "_ls-8";
export var toolbarCell = "_ls-a";
export var toolbarCellCollapsed = "_ls-b";
export var toolbarOptionHitArea = "_ls-c";
export var toolbarOverflow = "_ls-9";